import { useState, useEffect } from 'react';
import Config from '../config';
import Session from './Session';

export const useLocalStorage = (key, initialValue) => {
  const SESSION_USELOCALSTORAGE_KEY = `${Config.pronvest.sessionStorage.keyPrefix}_${key}`;
  const [value, setValue] = useState(() => {
    const parseValue = Session.get(SESSION_USELOCALSTORAGE_KEY);
    if (parseValue?.value != null) return parseValue.value;
    return initialValue;
  });

  useEffect(() => {
    Session.set(SESSION_USELOCALSTORAGE_KEY, { value });
  }, [SESSION_USELOCALSTORAGE_KEY, value]);

  return [value, setValue];
};
